import get from "lodash/get";
import React from "react";
import {connect} from "react-redux";
import { createDfpAdComponent } from '@quintype/components';

const viewPortSizeMappingHorizontal_728to320 = [ {viewport: [980, 90], sizes:[[728, 90]]},
                              {viewport: [320, 0], sizes:[[320, 50]]},
                              {viewport: [0, 0], sizes:[[320, 50]]}]
const viewPortSizeMappingVertical_600to250 = [ {viewport: [980, 90], sizes:[[300, 600]]},
                              {viewport: [320, 0], sizes:[[300, 250]]},
                              {viewport: [0, 0], sizes:[[300, 250]]}]
export const AD_CONFIG = {
  "Horizontal-Ad": { adUnit: "Horizontal_Responsive", sizes: [[728, 90], [320, 50]],
    viewPortSizeMapping: viewPortSizeMappingHorizontal_728to320
  },
  "Mrec": { adUnit: "Mrec", sizes: [[300,250]] },
  "Vertical-Ad": { adUnit: "Vertical_Responsive", sizes: [[300, 600], [300, 250]],
    viewPortSizeMapping: viewPortSizeMappingVertical_600to250
  },
  "Story-Mrec": { adUnit: "Story_Mrec", sizes: [[300,250]] },
  "Story-Middle-Ad": { adUnit: "Story_Middle_Responsive", sizes: [[728, 90], [320, 50]],
    viewPortSizeMapping: viewPortSizeMappingHorizontal_728to320
  },
  "Story-Bottom-Ad": { adUnit: "Story_Bottom_Responsive", sizes: [[728, 90], [320, 50]],
    viewPortSizeMapping: viewPortSizeMappingHorizontal_728to320
  }
}

function DfpAdBase(props) {
  if(props.disableAds) {
    return null;
  }
  const networkId = get(props, ['publisherTheme','dfp_network_id'], "60988533");
  const DfpAdWrapper = createDfpAdComponent({
    defaultNetworkID: networkId,
    config: AD_CONFIG,
    targeting: function(state) {
      // Params that can be derived from state.
      const params = {
        pageType: get(state, ['qt', 'pageType']),
        publisherName: get(state, ['qt', 'config', 'publisher-name']),
        publisherId: get(state, ['qt', 'config', 'publisher-id']),
        environment: get(state, ['qt', 'config', 'env'])
      };
      const sectionName = get(state, ['qt', 'data', 'section', 'name']);
      if(sectionName) params['sectionName'] = sectionName;
      const storyId = get(state, ['qt', 'data', 'story', 'id']);
      if(storyId) params['storyId'] = storyId;
      const sponsoredBy = get(state, ['qt', 'data', 'story', 'metadata','sponsored-by']);
      if(sponsoredBy) params['sponsoredBy'] = sponsoredBy;

      // Params that can't be derived from state, thus using props to pass it on.
      const layoutName = get(props, 'layoutName');
      if(layoutName) params['layoutName'] = layoutName;
      const collectionSlug = get(props, 'collectionSlug');
      if(collectionSlug) params['collectionSlug'] = collectionSlug;
      return params;
    }
  });
  return <DfpAdWrapper {...props}/>
}

function mapStateToProps(state) {
  return {
    publisherTheme: state.qt.config['theme-attributes'] || {},
    disableAds: state.qt.config['disable-ads']
  }
}

export const DfpAd = connect(mapStateToProps, () => ({}))(DfpAdBase);
